import DatePicker from 'react-datepicker'
import { IoIosCalendar } from 'react-icons/io'
import { memo } from 'react'
import { OrderType, Division } from '../constants/EnumType'
import ButtonGroup from "../components/ButtonGroup"
import SearchBox from "../components/SearchBox"
import SelectOption from '../components/SelectOption'
import SelectMultiOption from '../components/SelectMultiOption'
import { OrderType as ClaimRepack } from '../models'
import ExportAsButton from './ExportAsButton'

type HeaderListProps = {
  title?: string
  subTitle?: string
  orderType: string /* Mixing or Filling */
  statuses: string[] /* PD_XX or WH_YY */
  dateRange: [Date, Date]
  keywordSearch: string
  filterChanged: (key: string, value: string, dateRange? : [Date, Date], values?: string[]) => void
  coupleStatuses: string[],
  isAllOrderType?: boolean,
  searchable?: boolean,
  filterType?: boolean,
  isMultiStatus?: boolean,
  isSpanFilterType?: boolean,
  division?: string,
  filterNote?: boolean,
  note?: string,
  isExport?: boolean,
  onExportAs?: (type: string) => void
}

const DatePickerFilter = ({
  title, startDate, endDate, dispatchChanged, className
}: { 
  title?: string, startDate: Date, endDate: Date,
  dispatchChanged: (update : [Date, Date]) => void,
  className?: string
}) => {
  return <div className={className}>
    <small className={`text-muted${title ? '':' hidden'}`}>{title}</small>
    <div className="relative">
      <span className='absolute inset-y-0 left-0 z-10 flex items-center px-3 text-muted'>
        <IoIosCalendar />
      </span>
      <DatePicker
        selectsRange={true}
        className='mr-5 pl-9 input-form-date'
        onChange={dispatchChanged}
        startDate={startDate}
        endDate={endDate}
        dateFormat="dd/MM/yyyy"
      />
    </div>
  </div>
}

const HeaderList = ({
  title,
  subTitle,
  orderType,
  statuses,
  dateRange,
  keywordSearch,
  filterChanged,
  coupleStatuses,
  isAllOrderType = false,
  searchable = true,
  filterType = true,
  isMultiStatus = false,
  isSpanFilterType = false,
  division,
  filterNote = false,
  note = '',
  isExport = false,
  onExportAs
}: HeaderListProps) => {
  const [startDate, endDate] = dateRange;

  const orderTypeList = isAllOrderType ? 
    Object.keys(OrderType) : Object.keys(OrderType).filter(typ => typ !== 'All')
  
  const noteList = ['', 
    ...Object.keys(ClaimRepack).filter(k => k !== ClaimRepack.BULK && k !== ClaimRepack.FG)
  ]

  return <>
    <div className="flex flex-col items-center justify-between md:flex-row ">
      <div className='flex items-center gap-2'>
        <h3>{title}</h3>
        <h5 className="italic font-light ">{subTitle}</h5>
      </div>
      <SearchBox
        className={`${searchable ? 'block':'hidden'}`}
        placeholder='ค้นหาด้วย ORDER NO'
        value={keywordSearch}
        onChanged={keyword => filterChanged('Search', keyword)}/>
    </div>
    <div className={`grid grid-cols-2 md:grid-cols-3 ${filterNote ? 'lg:grid-cols-6' : 'lg:grid-cols-5'} gap-x-3`}>
      <DatePickerFilter
        title='Released Date Range'
        startDate={startDate}
        endDate={endDate}
        dispatchChanged={update => filterChanged('Released Date Range', '', update)}
      />
      {division ? <SelectOption title='Division' optionEnum={Object.keys(Division)}
        value={division} onChanged={(val) => filterChanged('Division', val)}/> : null}
      {filterType ? <SelectOption title='Order Type' optionEnum={orderTypeList}
        value={orderType} onChanged={(val) => filterChanged('Order Type', val)}/> : null}
      {filterNote ? <SelectOption title='Note (REPACK/CLAIM)' optionEnum={noteList}
        value={note} onChanged={(val) => filterChanged('Note', val)}/> : null}
      {isMultiStatus ? 
      <SelectMultiOption
        className={isSpanFilterType ? ' col-span-2' : ''}
        title='เลือกสถานะ'
        optionEnum={coupleStatuses}
        values={statuses}
        onChanged={(vals) => filterChanged('Status', '', undefined, vals)}
      /> : 
      <ButtonGroup
        className='flex self-end col-span-2 mt-3 h-fit'
				menus={coupleStatuses}
				onChanged={(idx) => filterChanged('Status', '', undefined, [coupleStatuses[idx]])}
				selectedIndex={coupleStatuses.findIndex(m => m === statuses[0])}
			/>
      }
      {isExport && onExportAs ? <div className='self-end col-span-2 justify-self-end'>
        <ExportAsButton onExportAs={onExportAs}/>
      </div> : null}
    </div>
  </>
}

export default memo(HeaderList)